import { inject } from '@angular/core';
import { EmployeePositionApiService } from '@shared/services';
import { PopoverHandlerConfig, PopoverConfig } from '../generic-popover.interfaces';
import { defaultCancelAction, defaultConfirmAction } from './default-actions';
import { changeTeamFormConfig } from '@shared/components/edit-create-form';

export const changeTeamPopoverConfig = (
  onSuccess: () => void,
  onCancel: () => void,
  actionHandlers?: Record<string, (popoverConfig: PopoverHandlerConfig, formValue: any) => void | Promise<any>>
): PopoverConfig => {
  const employeePositionApiService = inject(EmployeePositionApiService);

  return {
    width: '450px',
    title: 'Chuyển team',
    dismissable: true,
    styleClass: 'p-fluid',
    formConfig: changeTeamFormConfig(),
    actions: [defaultCancelAction, defaultConfirmAction],
    actionHandlers,
    handlerConfig: {
      service: employeePositionApiService,
      method: 'changeTeam',
      entityLabel: 'chuyển team',
      commonDataTransform: (formValue: any) => ({
        employeePositionId: formValue.employeePositionId,
        departmentId: formValue.departmentId,
        fromDate: formValue.fromDate
      }),
      initialDataTransform: (rawData: any) => ({
        employeePositionId: rawData.id,
        employee: rawData.employee,
        position: rawData.position,
        department: rawData.department,
        currentDepartment: rawData.department,
        departmentId: rawData.departmentId,
        rootDepartmentId: rawData.rootDepartmentId,
        fromDate: new Date(new Date().setHours(0, 0, 0, 0))
      }),
      onSuccess,
      onCancel
    } as PopoverHandlerConfig
  };
};
